import {StyleSheet} from 'react-native';

import {SIDE_PANEL_SETTINGS_COLOR} from 'style/theme';

import { TYPE, FONTS } from 'style/typography';

export const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 22,
    marginBottom: 10,
  },
  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 35,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  openButton: {
    backgroundColor: SIDE_PANEL_SETTINGS_COLOR,
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  textStyle: {
    color: 'white',
    fontFamily: FONTS.body,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    fontFamily: FONTS.body,
    textAlign: 'center',
  },
  topMargin: {
    marginTop: 20,
  },
  modalHeader: {
    fontSize: TYPE.xl,
    fontFamily: FONTS.body,
    fontWeight: 'bold',
  },
  modalIcon: {
    fontSize: TYPE['2xl'],
    fontFamily: FONTS.body,
  },
  micEnabledIcon: {
    color: '#000',
    fontSize: TYPE['4xl'],
    fontFamily: FONTS.body,
    textAlign: 'left',
    height: 40,
  },
  volumeTray: {
    width: 300,
    height: 48,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  volumeIndicator: {
    width: 200,
    height: 16,
  },
  videoPane: {
    width: 50,
    height: 50,
    margin: 10,
  },
});
